<template>
  <div v-html="text"></div>
</template>

<script setup>
import { computed } from 'vue'
import moment from 'moment-timezone'
import { useItineraryStore } from '@/stores/itinerary.js'

const store = useItineraryStore()

const { date, day, title, short } = defineProps({
  date: String,
  day: Number,
  title: String,
  short: Boolean,
})

const text = computed(() =>
  [
    day ? `Day ${day}` : null,
    date && day
      ? moment
          .tz(date, store.timezone)
          .add(day - 1, 'days')
          .format(short ? 'MMMM D' : 'MMMM D, YYYY')
      : null,
    title,
  ]
    .filter(Boolean)
    .join(' &middot; '),
)
</script>
